import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import category from "./category";
import salesMonth from "./salesMonth";
import customOrder from "./customOrder";
import goodTotal from "./goodTotal";
import shipment from "./shipment";
const Analysis = lazy(() => import("../view/analysis/Analysis"));
const Details = lazy(() => import("../view/details/Details"));
const InventoryDay = lazy(() => import("../view/inventoryDay/InventoryDay"));
const Goodlist = lazy(() => import("../view/goodlist/Goodlist"))
const orderDailyPaper = lazy(() => import("../view/orderDailyPaper/orderDailyPaper"))
const noOutDetail = lazy(() => import("../view/noOutDetail/NoOutDetail"))
const InventoryDay2 = lazy(() => import("../view/inventoryDay2/InventoryDay"));
const Goodlist2 = lazy(() => import("../view/goodlist2/Goodlist"));
const gylDailyForm = lazy(() => import("../view/gylDailyForm/GylDailyForm"));
const routes = [
  // {
  //   path: "/",
  //   element: <Navigate to="/analysis" replace />
  // },
  /**
   * 展厅库存分析
   */
  {
    path: "/analysis",
    // path: "/",
    component: Analysis,
  },
  {
    path: "/details",
    component: Details,
  },
  /**
   * 版库设计
   */
  {
    path: "/inventoryDay",
    component: InventoryDay,
  },
  {
    path: "/goodlist",
    component: Goodlist,
  },
  /**
   * 贵宝镶嵌部订单组日报
   */
  {
    path: "/orderDailyPaper",
    component: orderDailyPaper,
  },
  {
    path: "/noOutDetail",
    component: noOutDetail,
  },
  /**
   * 明丰版库设计
   */
  {
    path: "/mfInventoryDay",
    component: InventoryDay2,
  },
  {
    path: "/mfGoodlist",
    component: Goodlist2,
  },
  /**
   * 展厅品类&客户分析
   */
  {
    path: "/categoryCustom",
    children:category
  },
  /***
   * 月度业绩报表&业务员出货报表
   */
  {
    path: "/salesMonth",
    children:salesMonth
  },
  /**
   * 供应链每日报表
   */
  {
    path: "/gylDailyForm",
    component:gylDailyForm
  },
  /**
   * 客订单
   */
  {
    path:"customOrder",
    children:customOrder
  },
  // 统计
  {
    path:"goodTotal",
    children:goodTotal
  },
  // 展厅出货数据
  {
    path:"shipment",
    children:shipment
  }
];
export default routes;
